import { getHealthCareStatus } from '../services'
import { useQuery } from '@tanstack/react-query'

export const useGetHealthCareStatus = (enabled = true) => {
  return useQuery({
    queryKey: ['health-care-status'],
    queryFn: getHealthCareStatus,
    enabled,
  })
}
